import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { UserInfo } from '../../../common/model/dto/user-info';
import OvLabelledValue from '../atoms/OvLabelledValue';
import OvSearchTypeahead from './OvSearchTypeahead';

interface OvUserTypeaheadProps {
  placeholder?: string;
  onUserSelect?: (user: UserInfo | null) => void;
  fetchUsers: (searchText: string) => Promise<UserInfo[]> | undefined;
  className?: string;
}

const getUserName = ({ first_name, last_name }: UserInfo) =>
  first_name || last_name ? `${first_name} ${last_name}` : '';

const OvUserTypeahead: FC<OvUserTypeaheadProps> = ({
  placeholder,
  onUserSelect,
  fetchUsers,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <OvSearchTypeahead<UserInfo>
      searchKey="users"
      fetchOptions={fetchUsers}
      getOptionLabel={getUserName}
      onSelect={onUserSelect}
      placeholder={placeholder}
      className={className}
      renderOption={(props, user) => (
        <OvLabelledValue
          {...props}
          items={[
            ...(getUserName(user) ? [{ value: getUserName(user) }] : []),
            ...(user.email
              ? [{ label: t('common.userFields.email'), value: user.email }]
              : []),
          ]}
        />
      )}
    />
  );
};

export default OvUserTypeahead;
